"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JobsService = function JobsService(HttpService) {
  "ngInject";

  var getDataSource = function getDataSource(successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("jobs/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total"
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  var getJobPaymentDetails = function getJobPaymentDetails(jobId, successCb, failureCb) {
    HttpService.get("jobs/" + jobId + "/payment-details", successCb, failureCb);
  };

  var getJobDetails = function getJobDetails(jobId, successCb, failureCb) {
    HttpService.get("jobs/" + jobId, successCb, failureCb);
  };

  var updateJobPricing = function updateJobPricing(jobId, data, successCb, failureCb) {
    HttpService.put("jobs/" + jobId + "/pricing", data, successCb, failureCb);
  };

  var payHelper = function payHelper(invoiceId, successCb, failureCb) {
    console.log('JobsService.payHelper called with invoiceId:', invoiceId);
    HttpService.post("payments/helper/" + invoiceId, null, successCb, failureCb);
  };

  var deleteTimesheet = function deleteTimesheet(jobId, successCb, failureCb) {
    HttpService.patch("jobs/" + jobId + "/timesheet", { status: 12 }, successCb, failureCb);
  };

  var getJugglerJobsDataSource = function getJugglerJobsDataSource(userId) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("jobs/juggler/" + userId),
          contentType: "application/json",
          type: "GET",
          cache: false,
          beforeSend: _onBeforeSend
        },
        update: {
          url: function url(item) {
            return _env2.default.getApiUrl("jobs/" + (item.id || item.jobId || item.JobId || item.Id) + "/pricing");
          },
          contentType: "application/json",
          type: "PUT",
          beforeSend: _onBeforeSend
        },
        parameterMap: function parameterMap(data, type) {
          if (type === "update") {
            return (0, _stringify2.default)({
              price: data.price || data.Price,
              overtimeRate: data.overtimeRate || data.OvertimeRate,
              estimatedJobValue: data.estimatedJobValue || data.EstimatedJobValue
            });
          }
        }
      },
      schema: {

        model: {
          id: "id", // Assuming id or jobId is present. Handled in update url safely.
          fields: {
            id: { editable: false },
            jobId: { editable: false },
            paymentType: { editable: false },
            PaymentType: { editable: false },
            jobDate: { editable: false },
            JobDate: { editable: false },
            jobStartTime: { editable: false },
            JobStartTime: { editable: false },
            jobEndTime: { editable: false },
            JobEndTime: { editable: false },
            estimatedJobHours: { editable: false },
            EstimatedJobHours: { editable: false },
            price: { type: "number", validation: { min: 0 } },
            Price: { type: "number", validation: { min: 0 } },
            overtimeRate: { type: "number", validation: { min: 0 } },
            OvertimeRate: { type: "number", validation: { min: 0 } },
            estimatedJobValue: { type: "number", validation: { min: 0 } },
            EstimatedJobValue: { type: "number", validation: { min: 0 } }
          }
        }
      },
      serverFiltering: false,
      serverPaging: false,
      serverSorting: false,
      pageSize: 50
    });

    return dataSource;
  };

  return { getDataSource: getDataSource, getJugglerJobsDataSource: getJugglerJobsDataSource, getJobPaymentDetails: getJobPaymentDetails, getJobDetails: getJobDetails, updateJobPricing: updateJobPricing, payHelper: payHelper, deleteTimesheet: deleteTimesheet };
};

function _getResourceLocation(options) {
  return _env2.default.getApiUrl("bigfoot/medias/" + options.id);
}

function _onBeforeSend(req) {
  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read") {
    var filters = [];

    if (data.filter) filters = data.filter.filters;

    var query = (0, _assign2.default)({}, { filters: filters }, data);
    delete query.filter;

    console.log("Query::", query);

    return (0, _stringify2.default)(query);
  }

  if (type == "update") {
    return (0, _stringify2.default)(data);
  }
}

exports.default = JobsService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/jobs.service.js
 **/